<template>
	<div id="Orders" class="box">
		<UpdatePaymentInformation :order="this.orderItem"  v-if="showUpdateForm" @update-orders="onUpdateOrders" @close="toggleCardUpdateModal" />
		<div id="OrdersDetails">
			<div>
				<h3>Your Orders</h3>
				<div class="center" v-if="orders.loading === true">
					<LoadingSpinner />
				</div>
				<div v-if="orders.loading !== true && orders.loaded !== true" style="text-align: center;">
					<button type="button" @click.prevent="Load()"><i class="fas fa-sync-alt"></i> Load Orders</button>
				</div>
				<div v-if="orders.loading !== true && orders.loaded === true && user_orders.length < 1">
					<div style="text-align: center;font-size:.7em;margin-bottom:10px;"><h4 style="color:red !important;">No Orders Found</h4></div>
					<div style="text-align: center;">
						<button type="button" @click.prevent="Load()"><i class="fas fa-sync-alt"></i> Reload Orders</button>
					</div>
				</div>
				<div v-if="orders.loading !== true && orders.loaded === true && user_orders.length > 0">
					<table id="user-orders" class="creds-table">
						<thead>
							<tr>
								<th>OrderId</th>
								<th>Status</th>
								<th>Total</th>
								<th>Placed On</th>
								<th>Receipt</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="order in user_orders" v-bind:id="order.id" v-bind:key="order.id">
								<td>{{ FormatOrderNumber(order.id, order.created_at.date) }}</td>
								<td v-html="FormatStatus(order)"></td>
								<td>${{ order.amt_total }} {{ order.currency }}</td>
								<td>{{ FormatDate(order.created_at) }}</td>
								<td>
									<span class="hide" v-bind:id="`send_order_${order.id}`">SENDING</span>
									<a
										v-bind:id="`order_${order.id}`"
										href="#"
										v-if="(order.payment_status !== 'Created')"
										v-on:click="
										Email($event, order.id);
										return false;
										"
										>Resend Email
									</a>
									<span v-if="(order.payment_status === 'Created')">
										N/A
									</span>
								</td>
								<td>
									<button type="button" v-if="order.has_future_installments" @click.prevent="toggleCardUpdateModal(order)" id="update-card-info"> Update Payment Method </button>
								</td>
							</tr>
						</tbody>
					</table>
					<div style="text-align: center;">
						<button type="button" @click.prevent="Load()"><i class="fas fa-sync-alt"></i> Reload Orders</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import LoadingSpinner from "./LoadingSpinner.vue";
import UpdatePaymentInformation from "./UpdatePaymentInformation.vue";

export default {
	name: "Orders",
	components: {
		LoadingSpinner,
		UpdatePaymentInformation
	},
	data() {
		return {
			orders: window.portal.orders,
			user_orders: window.portal.orders.orders,
			showUpdateForm: false,
			order: null,
			inView: false,
		};
	},
	computed: {
		orderItem() {
			return this.order;
		},
	},
	mounted: function () {
		this.orders.loading = false;

		window.addEventListener("scroll", this.handleScroll);
	},
	methods: {
		onUpdateOrders() {
			// Update orders after updating payment
			this.Load();
			// Update Installments after updating payment
			this.$emit('update-installments');
		},
		FormatStatus(order) {
			// Format the status of the order based on columns on order
			const initialString = "<strong>";
			let htmlString = initialString;
			// link uppercase column names to the display class
			const statusClasses = {
				Paid: 'success',
				Canceled: 'error',
				Refunded: 'success',
			};
			Object.keys(statusClasses).forEach(key => {
				if (order.[key.toLowerCase()]) {
					htmlString += ` <span class="${statusClasses[key]}">${key}</span> `;
				}
			});
			// If no text has been added, just use the payment_status column
			if (htmlString === initialString) {
				htmlString += `<span>${order.payment_status}</span>`;
			}

			htmlString += "</strong>";
			return htmlString;
		},
		FormatOrderNumber(order_num, date) {
			const d = new Date(date);
			window.debug(
					`ORDER FOUND: ${String(order_num).padLeft(
							8,
							"0"
					)}${d.getFullYear()}${String(d.getMonth()).padLeft(2, "0")}${String(
							d.getDate()
					).padLeft(2, "0")}${String(d.getHours()).padLeft(2, "0")}`
			);
			/*long order number*/ // return `${String(order_num).padLeft(8,'0')}${d.getFullYear()}${String(d.getMonth()).padLeft(2,'0')}${String(d.getDate()).padLeft(2,'0')}${String(d.getHours()).padLeft(2,'0')}`;
			return `${order_num}`;
		},
		FormatDate(date) {
			try {
				const localeDate = new Intl.DateTimeFormat("en-US");
				return localeDate.format(new Date(date));
			} catch (e) {
				console.log(e);
			}
		},
		toggleCardUpdateModal(order = null) {
			if (order) {
				this.order = order;
			}
			this.showUpdateForm = !this.showUpdateForm;
		},
		Clear() {
			window.portal.clearOrders();
		},
		Load() {
			console.log("loading orders")
			this.orders.loading = true;
			this.$forceUpdate();
			window.portal.orders.loaded = false;
			axios.defaults.headers.common["X-Auth-Token"] =
					window.portal.session.token;
			axios
					.post(`${window.portal.api_server}/userportal/orders`, {
						confirm: window.portal.user.id.decode().encode(),
					})
					.then((res) => {
						if (res.data.status.success) {
							this.user_orders = res.data.data;
							window.portal.orders.loaded = true;
							this.orders.loading = false;
							this.$forceUpdate();
							window.debug(res.data.data);
							window.debug("USER ORDERS LOADED");
						}
					})
					.catch((err) => {
						window.portal.orders.loaded = false;
						this.orders.loading = false;
						window.debug("USER ORDERS FAILURE");
						window.debug(err);
						window.portal.logout();
					});
		},
		Email(event, order_id) {
			event.preventDefault();
			document.getElementById(`order_${order_id}`).classList.add("hide");
			document.getElementById(`send_order_${order_id}`).classList.remove("hide");
			axios.defaults.headers.common["X-Auth-Token"] = window.portal.session.token;
			axios
					.post(`${window.portal.api_server}/userportal/orderreemail`, {
						confirm: window.portal.user.id.decode().encode(),
						order: String(order_id).encode(),
					})
					.then((res) => {
						if (res.data.status.success) {
							window.debug(res.data.data);
							window.debug("ORDER EMAILED");
						}
					})
					.catch((err) => {
						window.debug("ORDER EMAIL FAILURE");
						window.debug(err);
						window.portal.logout();
					});
		},
		handleScroll() {
			const element = this.$el;
			const elementRect = element.getBoundingClientRect();
			const inView = elementRect.top < window.innerHeight && elementRect.bottom >= 0;
			if (inView && !this.inView) {
				this.inView = true;
				this.Load();
			}
		},
	},
};
</script>

<style>
#Orders h3 {
	text-transform: uppercase;
	text-align: center;
	font-size: 24px;
	padding: 15px;
	margin: 0;
}
@media only screen and (max-width: 800px) {
	#user-orders th:nth-child(4) {
		display: none;
	}
	#user-orders td:nth-child(4) {
		display: none;
	}
}
@media only screen and (max-width: 600px) {
	#user-orders th:nth-child(3) {
		display: none;
	}
	#user-orders td:nth-child(3) {
		display: none;
	}
}
</style>